<template>
  <div>
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">恒宝宝交易记录</span>
        <Reback class="row-one-fr" @click.native="returnClick"></Reback>
        <span class="row-one-fr" @click="detailsClick">查看资产详情</span>
      </el-row>
      <!-- 主页 -->
      <div>
        <el-form :model="searchForm" class="form-single-inline margin-t20">
          <el-form-item label="起止日期：">
            <el-radio-group v-model="searchForm.datetype" class="radio-single-btn1" @change="dateChange">
              <el-radio-button v-for="(item,i) in setTimeData" :label="item.time" :key="i+'dt'">{{item.name}}</el-radio-button>
            </el-radio-group>
            <!-- 日期选择 -->
            <el-date-picker v-model="searchForm.datevalue1" type="date" placeholder="选择日期" @change="dateOneChange">
            </el-date-picker>
            至
            <el-date-picker v-model="searchForm.datevalue2" type="date" placeholder="选择日期" @change="dateTwoChange">
            </el-date-picker>
            <el-button type="search" class="margin-l10" @click="searchClick">查询 <i class="el-icon-search"></i></el-button>
          </el-form-item>
          <!-- 交易类型 -->
          <el-form-item label="交易类型：">
            <el-radio-group v-model="searchForm.type" class="radio-single-btn1" @change="tradeTypeClick">
              <el-radio-button v-for="(item,i) in tradeTypeData" :label="item.value" :key="i+'lx'">{{item.name}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <!-- 表格 -->
        <el-table :data="tradeTableData" class="table-single margin-t20" stripe v-loading="loading" element-loading-text="加载中...">
          <el-table-column prop="applyTime" label="申请时间"></el-table-column>
          <el-table-column prop="tradeType" label="交易类型"></el-table-column>
          <el-table-column prop="transamount" label="金额（元）"></el-table-column>
          <el-table-column prop="relatedAccount" label="关联账户"> </el-table-column>
          <el-table-column prop="status" label="交易状态"></el-table-column>
          <el-table-column prop="details" label="操作">
            <template slot-scope="scope">
              <span :class="scope.row.tradeType == '--'?'table-single-btn-forbid':'table-single-btn-normal' " @click="tradeDetails(scope.row)">详情</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 页码 -->
        <el-pagination class="pagination-single" @current-change="handleCurrentChangeOne" :current-page.sync="trade.Page" :page-size="trade.PageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
        </el-pagination>
      </div>

    </div>
    <!-- 功能开发中 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable1" :show-close="false">
      <img src="../../../assets/images/development.png" alt="" style="width:120px;height:110px;">
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="dialogVisable1 = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "record",
  data () {
    return {
      dialogVisable1: false,
      searchForm: {
        datetype: this.$commonJs.getBeforeDate(7, 'd7', '/'),
        datevalue1: this.$commonJs.getBeforeDate(7, 'd7', '/'),
        datevalue2: this.$commonJs.getBeforeDate(0, 'd7', '/'),
        type: '',
      },
      tradeTableData: [],
      trade: {
        Page: 1,
        PageNum: 20
      },
      total: 0,
      // 时间多选
      setTimeData: [
        {
          name: '全部',
          value: 'all',
          time: ''
        },
        {
          name: '近一周',
          value: 'oneWeek',
          time: this.$commonJs.getBeforeDate(7, 'd7', '/')
        },
        {
          name: '近一月',
          value: 'oneMonth',

          time: this.$commonJs.getBeforeDate(0, 1, '/')
        },
        {
          name: '近三月',
          value: 'threeMonth',

          time: this.$commonJs.getBeforeDate(0, 3, '/')
        },
        {
          name: '近半年',
          value: 'halfYear',

          time: this.$commonJs.getBeforeDate(0, 6, '/')
        },
        {
          name: '近一年',
          clickName: 'oneYear',

          time: this.$commonJs.getBeforeDate(0, 12, '/')
        }
      ],
      // 交易类型
      tradeTypeData: [
        {
          name: '不限',
          value: '',
        },
        {
          name: '充值',
          value: '22'
        },
        {
          name: '定投',
          value: '39'
        },
        {
          name: '提现',
          value: '24'
        },
        {
          name: '分红',
          value: '43'
        },
        {
          name: '基金买入',
          value: '124'
        },
        {
          name: '基金卖出',
          value: '122'
        },
      ],
      // 充值
      stepDisplay: '1',
      loading: true,

    }
  },
  mounted () {
    this.getQeryPublicTrades()
  },
  methods: {
    returnClick () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    detailsClick () {
      this.$router.push({
        name: 'hbbAssetsMessage',
        params: {
          value: 'record'
        },
      })
    },
    handleCurrentChangeOne (newPage) {
      this.loading = true
      this.trade.Page = newPage
      this.getQeryPublicTrades()
    },
    // 选项时间
    dateChange (val) {
      this.searchForm.datevalue1 = val
      this.searchForm.datevalue2 = this.$commonJs.getBeforeDate(0, 'd7', '/')
    },
    // 开始日期
    dateOneChange (val) {
      this.searchForm.datetype = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '')
      this.searchForm.datevalue1 = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '/')
    },
    // 结束日期
    dateTwoChange (val) {
      this.searchForm.datevalue2 = this.$commonJs.timeFormat(val).substring(0, 10).replace(/-/g, '/')
    },
    // 查询
    searchClick () {
      this.loading = true
      this.trade.Page = 1
      this.getQeryPublicTrades()
    },
    //交易变化
    tradeTypeClick (val) {
      // this.loading = true
      // console.log(val)
      this.searchForm.type = val
      // this.getQeryPublicTrades()
    },
    // 详情
    tradeDetails (row) {
      this.$router.push({
        name: 'recordDetail',
        params: {
          message: row
        }
      })
    },
    getQeryPublicTrades () {
      let begin = ''
      if (this.searchForm.datetype == '') {
        begin = this.$commonJs.getBeforeDate(0, 36, '')
      } else {
        begin = this.searchForm.datevalue1.replace('/', '').replace('/', '')
      }
      this.$http.post(this.$apiPath.qeryPublicTrades, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        custno: this.$commonJs.getCookie('u_custno1'),//
        paycenterid: "",//支付渠道
        begindate: begin,
        enddate: this.searchForm.datevalue2.replace('/', '').replace('/', ''),
        businesscode: this.searchForm.type,//交易类型  businesscode 充值22    定投39   普通体现 24    分红 43     122基金卖出  124基金买入  
        fundcode: "162206",//基金代码
        transstatus: "",//业务种类
        transcode: "",//业务种类筛选
        status: "",//状态筛选
        appnew: 1,
        requestid: this.trade.Page//页数
      }).then(res => {
        // console.log(res);
        this.loading = false
        if (res.status !== 200) return
        const result = res.data.data
        if (result && result.publicRecord.length > 0) {
          result.publicRecord.forEach(item => {
            item.applyTime = this.$commonJs.getDateStrTh(item.operdate) + ' ' + ' ' + item.opertime
            // 关联账户
            item.relatedAccount = "银行卡(" + item.depositacct.substr(item.depositacct.length - 4) + ")"
            // 交易类型
            if (item.businesscode == "22") {
              if (item.transstatus == "05") {
                item.tradeType = item.paytype == "2" ? '汇款订单' : '充值'
              } else {
                item.tradeType = "充值"
              }
            } else if (item.businesscode == "39") {
              item.tradeType = "定期定额申购"
            } else if (item.businesscode == "59") {
              item.tradeType = "定期定额充值开通"
            } else if (item.businesscode == "60") {
              item.tradeType = "定期定额充值终止"
            } else if (item.businesscode == "24") {
              item.tradeType = "普通提现"
            } else if (item.businesscode == "43") {
              item.tradeType = "分红"
            } else if (item.businesscode == "122") {
              item.tradeType = "卖出基金到恒宝宝"
              item.relatedAccount = "恒宝宝"
            } else if (item.businesscode == "124") {
              item.tradeType = "恒宝宝买基金"
              item.relatedAccount = "恒宝宝"
            } else {
              item.tradeType = "--"
            }

            // 交易状态
            if (item.transstatus == "00") {
              // if()
              item.status = '已撤单'
            } else if (item.transstatus == "01") {
              item.status = '确认成功'
            } else if (item.transstatus == "02") {
              item.status = '确认失败'
            } else if (item.transstatus == "03") {
              item.status = '确认中'
            } else if (item.transstatus == "04") {
              item.status = '受理失败'
            } else if (item.transstatus == "05") {
              item.status = item.paytype == "2" ? '汇款待确认' : '支付失败'
            } else if (item.transstatus == "06") {
              item.status = '交易失败'
            } else if (item.transstatus == "07") {
              item.status = '带勾兑'
            } else if (item.transstatus == "08") {
              item.status = '异常'
            }
          });
        }

        this.tradeTableData = result.publicRecord
        this.total = result.totalNum
      })
    }
  }
}
</script>

<style lang="less" scoped>
.startEndDate {
  margin-top: 22px;
  margin-bottom: 14px;
  .el-button {
    width: 72px;
    height: 32px;
    border-radius: 0;
  }
}
.tradeType {
  margin-bottom: 22px;
  .el-button {
    width: 72px;
    height: 32px;
    border-radius: 0;
  }
}
.tableBtn .el-button {
  width: 55px;
  height: 22px;
  border-radius: 0;
}
.active {
  background-color: #000;
}
// 按钮样式
.tradeTypeBtn {
  display: inline-block;
  width: 69px;
  height: 30px;
  margin-right: 10px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  border: 1px solid @colorC3;
}
.active {
  background: @color;
  color: @wColor;
  border-color: @color;
}
</style>
